@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Brand Header -->
<div
  class="relative mb-2 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between flex-wrap gap-2 px-5 py-3 relative"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <div
        class="absolute inset-0"
        style="
          opacity: 0.12;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.1);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.08);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 250px;
          top: 6px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 8px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.18);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Route Deviation Analytics Dashboard
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Actions -->
    <div class="relative flex items-center gap-2 flex-wrap">
      @if (filters == true) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Hide Filters
      </button>
      } @if (filters == false) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #475569, #334155);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(71, 85, 105, 0.3);
        "
      >
        <span nz-icon nzType="filter" nzTheme="outline"></span>
        Show Filters
      </button>
      } @if (cameFromStateDashboard) {
      <button
        (click)="goBackToStateDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg transition-all font-semibold cursor-pointer"
        style="
          font-size: 12px;
          background: linear-gradient(135deg, #0f766e, #134e4a);
          color: #fff;
          border: none;
          box-shadow: 0 1px 3px rgba(15, 118, 110, 0.3);
        "
        title="Back to State Trips Dashboard"
      >
        <i nz-icon nzType="left" nzTheme="outline" style="font-size: 14px"></i>
        Back
      </button>
      }
    </div>
  </div>
</div>

<div class="mx-auto">
  <!-- Enhanced Modern Filter Section -->
  @if (filters) {
  <div
    class="bg-gradient-to-r from-slate-50 to-gray-50 rounded-xl shadow-sm p-4 mb-3 border border-gray-200 fltrsctn"
  >
    <div class="flex items-center gap-3 flex-wrap">
      <!-- Date Filter -->
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >Date</label
        >
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input w-full"
        >
        </nz-date-picker>
      </div>
      <!-- ULB Filter (Multiple) -->
      @if (tntLst.length>1) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >ULB</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select ULB"
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [nzDisabled]="cameFromStateDashboard"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!cameFromStateDashboard) {
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          } @for (t of tntLst; track t) { @if (!cameFromStateDashboard ||
          t.tnt_id === selectedtenant) {
          <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_dsply_nm">
          </nz-option>
          } }
        </nz-select>
      </div>
      }
      <!-- ULB Filter (Single) -->
      @if (tntLst.length==1) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >ULB</label
        >
        <div class="filter-static-input w-full">
          {{ tntLst[0].tnt_nm }}
        </div>
      </div>
      }
      <!-- Sachivalayam Filter -->
      @if (selectedtenant > 0 && svmLst && svmLst.length > 0) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >Sachivalayam</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select"
          [(ngModel)]="slctdSvm"
          (ngModelChange)="selectSachvalayam($event)"
          class="filter-input w-full"
        >
          @if (userDtls.rle_id!=37) {
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          } @for (c of svmLst; track c) {
          <nz-option [nzLabel]="c.svm_nm" [nzValue]="c.svm_id"></nz-option>
          }
        </nz-select>
      </div>
      }
      <!-- Vendor Filter -->
      @if (ShowClap) {
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          class="text-[11px] font-semibold text-gray-500 mb-1.5 uppercase tracking-wide"
          >Vendor</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="Select Vendor"
          [(ngModel)]="selectedvndr"
          (ngModelChange)="onvndrSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          @if (!showVndr) {
          <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
          } @for (v of vendorList; track v) {
          <nz-option [nzValue]="v.vndr_id" [nzLabel]="v.vndr_nm"></nz-option>
          }
        </nz-select>
      </div>
      }
      <!-- Submit Button -->
      <button nz-button nzType="primary" class="submit-btn flex-shrink-0 mt-2">
        <i nz-icon nzType="search" nzTheme="outline" class="text-sm"></i>
        <span>Search</span>
      </button>
    </div>
  </div>
  }

  <!-- Colorful Statistics Cards with Horizontal Layout -->
  @if (rdCnts && rdCnts.length>0) {
  <div
    class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-5 mb-4"
  >
    <!-- Trips Card -->
    <div
      class="bg-gradient-to-br from-emerald-400 via-emerald-500 to-teal-500 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-emerald-300 overflow-hidden"
    >
      <div class="p-3">
        <!-- Header -->
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
              ></path>
              <path
                d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
              ></path>
            </svg>
            Trips
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <!-- Horizontal Stats with Dividers -->
        <div class="flex items-center justify-between">
          <!-- Total -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === null && selectedSortType === 'trips'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(null, 'trips')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ rdCnts[0].ttl_trps === null ? "0" : rdCnts[0].ttl_trps }}
            </div>
            <div class="text-xs font-semibold text-emerald-50 uppercase">
              Total
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Primary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 1 && selectedSortType === 'trips'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(1, 'trips')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ rdCnts[0].prmry_trps === null ? "0" : rdCnts[0].prmry_trps }}
            </div>
            <div class="text-xs font-semibold text-emerald-50 uppercase">
              Primary
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Secondary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 0 && selectedSortType === 'trips'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(0, 'trips')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ rdCnts[0].scndry_trps === null ? "0" : rdCnts[0].scndry_trps }}
            </div>
            <div class="text-xs font-semibold text-emerald-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Travelled Trips Card -->
    <div
      class="bg-gradient-to-br from-cyan-400 via-cyan-500 to-blue-500 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-cyan-300 overflow-hidden"
    >
      <div class="p-3">
        <!-- Header -->
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Travelled Trips
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <!-- Horizontal Stats with Dividers -->
        <div class="flex items-center justify-between">
          <!-- Total -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === null && selectedSortType === 'trvl'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(null, 'trvl')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].trvl_ttl_trps === null ? "0" : rdCnts[0].trvl_ttl_trps
              }}
            </div>
            <div class="text-xs font-semibold text-cyan-50 uppercase">
              Total
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Primary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 1 && selectedSortType === 'trvl'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(1, 'trvl')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].trvl_prmry_trps === null
                  ? "0"
                  : rdCnts[0].trvl_prmry_trps
              }}
            </div>
            <div class="text-xs font-semibold text-cyan-50 uppercase">
              Primary
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Secondary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 0 && selectedSortType === 'trvl'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(0, 'trvl')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].trvl_scndry_trps === null
                  ? "0"
                  : rdCnts[0].trvl_scndry_trps
              }}
            </div>
            <div class="text-xs font-semibold text-cyan-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Route Deviated Trips Card -->
    @if (clntDtls[0].clnt_id!=3000001) {
    <div
      class="bg-gradient-to-br from-red-400 via-red-500 to-pink-500 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-red-300 overflow-hidden"
    >
      <div class="p-3">
        <!-- Header -->
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Route Deviated
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <!-- Horizontal Stats with Dividers -->
        <div class="flex items-center justify-between">
          <!-- Total -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === null && selectedSortType === 'rd'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(null, 'rd')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ rdCnts[0].ttl_rd_trps === null ? "0" : rdCnts[0].ttl_rd_trps }}
            </div>
            <div class="text-xs font-semibold text-red-50 uppercase">Total</div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Primary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 1 && selectedSortType === 'rd'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(1, 'rd')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].prmry_rd_trps === null ? "0" : rdCnts[0].prmry_rd_trps
              }}
            </div>
            <div class="text-xs font-semibold text-red-50 uppercase">
              Primary
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Secondary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 0 && selectedSortType === 'rd'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(0, 'rd')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].scndry_rd_trps === null
                  ? "0"
                  : rdCnts[0].scndry_rd_trps
              }}
            </div>
            <div class="text-xs font-semibold text-red-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- Not Travelled Trips Card -->
    @if (clntDtls[0].clnt_id!=3000001) {
    <div
      class="bg-gradient-to-br from-blue-400 via-indigo-500 to-purple-500 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-blue-300 overflow-hidden"
    >
      <div class="p-3">
        <!-- Header -->
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Not Travelled
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <!-- Horizontal Stats with Dividers -->
        <div class="flex items-center justify-between">
          <!-- Total -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === null && selectedSortType === 'nt'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(null, 'nt')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].nt_trvl_ttl_trps === null
                  ? "0"
                  : rdCnts[0].nt_trvl_ttl_trps
              }}
            </div>
            <div class="text-xs font-semibold text-blue-50 uppercase">
              Total
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Primary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 1 && selectedSortType === 'nt'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(1, 'nt')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].nt_trvl_prmry_trps === null
                  ? "0"
                  : rdCnts[0].nt_trvl_prmry_trps
              }}
            </div>
            <div class="text-xs font-semibold text-blue-50 uppercase">
              Primary
            </div>
          </div>
          <!-- Vertical Divider -->
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <!-- Secondary -->
          <div
            class="flex-1 text-center cursor-pointer hover:scale-110 transition-all duration-200 rounded-lg py-1 px-2"
            [ngClass]="
              selectedSortId === 0 && selectedSortType === 'nt'
                ? 'bg-white/30 ring-2 ring-white/80 shadow-lg scale-105'
                : ''
            "
            (click)="getsort(0, 'nt')"
          >
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{
                rdCnts[0].nt_trvl_scndry_trps === null
                  ? "0"
                  : rdCnts[0].nt_trvl_scndry_trps
              }}
            </div>
            <div class="text-xs font-semibold text-blue-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
  <div class="flex items-center gap-3 my-5 px-2">
    <div class="flex items-center gap-2.5">
      <div
        class="w-9 h-9 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-lg shadow-md flex items-center justify-center"
      >
        <svg
          class="w-5 h-5 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
          ></path>
        </svg>
      </div>
      <h2
        class="text-lg font-bold bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent"
      >
        Vehicle Wise Analysis
      </h2>
    </div>
    <div
      class="flex-1 h-px bg-gradient-to-r from-blue-200 via-indigo-200 to-transparent"
    ></div>
  </div>
  <!-- State-wise Vehicle, Trips & Routes Summary Cards -->
  @if (ttlTrpsCnt && ttlTrpsCnt.length > 0) {
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mb-4">
    <!-- Total Vehicles Card -->
    <div
      class="bg-gradient-to-br from-violet-400 via-violet-500 to-purple-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-violet-300 overflow-hidden"
    >
      <div class="p-3">
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
              ></path>
              <path
                d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z"
              ></path>
            </svg>
            Total Vehicles
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].ttl_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-violet-50 uppercase">
              Total
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].primary_ttl_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-violet-50 uppercase">
              Primary
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].secondary_ttl_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-violet-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Total Trips Created Card -->
    <!-- <div class="bg-gradient-to-br from-amber-400 via-amber-500 to-yellow-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-amber-300 overflow-hidden">
      <div class="p-3">
        <div class="mb-4">
          <h3 class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clip-rule="evenodd"></path>
            </svg>
            Total Trips Created
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">{{ttlTrpsCnt[0].def_trps || 0}}</div>
            <div class="text-xs font-semibold text-amber-50 uppercase">Total</div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">{{ttlTrpsCnt[0].primary_def_trps || 0}}</div>
            <div class="text-xs font-semibold text-amber-50 uppercase">Primary</div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">{{ttlTrpsCnt[0].secondary_def_trps || 0}}</div>
            <div class="text-xs font-semibold text-amber-50 uppercase">Secondary</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Routes Defined Vehicles Card -->
    <div
      class="bg-gradient-to-br from-teal-400 via-teal-500 to-green-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-teal-300 overflow-hidden"
    >
      <div class="p-3">
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Routes Defined
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].rts_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-teal-50 uppercase">
              Total
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].primary_rts_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-teal-50 uppercase">
              Primary
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].secondary_rts_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-teal-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Routes Not Defined Vehicles Card -->
    <div
      class="bg-gradient-to-br from-rose-400 via-rose-500 to-pink-600 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border-2 border-rose-300 overflow-hidden"
    >
      <div class="p-3">
        <div class="mb-4">
          <h3
            class="text-sm font-bold uppercase tracking-wider text-white text-center drop-shadow-sm flex items-center justify-center gap-2"
          >
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Routes Not Defined
          </h3>
          <div class="h-0.5 bg-white/80 w-full"></div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].rts_not_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-rose-50 uppercase">
              Total
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].primary_rts_not_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-rose-50 uppercase">
              Primary
            </div>
          </div>
          <div class="h-12 w-0.5 bg-white/40 mx-2"></div>
          <div class="flex-1 text-center rounded-lg py-1 px-2">
            <div class="text-2xl font-bold text-white mb-1 drop-shadow-md">
              {{ ttlTrpsCnt[0].secondary_rts_not_dfnd_vhcls || 0 }}
            </div>
            <div class="text-xs font-semibold text-rose-50 uppercase">
              Secondary
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  <!-- Enhanced Modern Search and Filter Section - Hidden by Default -->
  @if (showSearchFilters) {
  <div
    class="bg-white rounded-xl shadow-lg p-3 mb-3 border border-gray-200 border-t-4 border-t-purple-500 transition-all duration-300 ease-in-out"
  >
    <div
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end"
    >
      <div class="flex flex-col h-full">
        <label class="block text-sm font-semibold text-gray-700 mb-2"
          >Select Category</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Category"
          [(ngModel)]="selectedCtgry"
          (ngModelChange)="selectCategory($event)"
          class="w-full filter-input-height"
        >
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          @for (c of vehCtgrys; track c) {
          <nz-option
            [nzLabel]="c.asrt_ctgry_nm"
            [nzValue]="c.asrt_ctgry_id"
          ></nz-option>
          }
        </nz-select>
      </div>
      <div class="flex flex-col h-full">
        <label class="block text-sm font-semibold text-gray-700 mb-2"
          >Select Start Location</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Start Location"
          [(ngModel)]="strt_loc"
          (ngModelChange)="onselectStrtLctn($event)"
          class="w-full filter-input-height"
        >
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          @for (l of tripLoctns; track l) {
          <nz-option
            [nzLabel]="l.strt_fnce_nm"
            [nzValue]="l.strt_fnce_id"
          ></nz-option>
          }
        </nz-select>
      </div>
      <div class="flex flex-col h-full">
        <label class="block text-sm font-semibold text-gray-700 mb-2"
          >Select End Location</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="End Location"
          [(ngModel)]="end_loc"
          (ngModelChange)="onselectEndLctn($event)"
          class="w-full filter-input-height"
        >
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          @for (l of tripEndLoctns; track l) {
          <nz-option
            [nzLabel]="l.end_fnce_nm"
            [nzValue]="l.end_fnce_id"
          ></nz-option>
          }
        </nz-select>
      </div>
      @if (wrds && wrds.length > 0 && clntDtls[0].clnt_id!=7) {
      <div class="flex flex-col h-full">
        <label class="block text-sm font-semibold text-gray-700 mb-2"
          >Select Ward</label
        >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Ward"
          [(ngModel)]="slctdWrd"
          (ngModelChange)="selectWard($event)"
          class="w-full filter-input-height"
        >
          <nz-option nzLabel="All" [nzValue]="0"></nz-option>
          @for (c of wrds; track c) {
          <nz-option [nzLabel]="c.wrd_nm" [nzValue]="c.wrd_id"></nz-option>
          }
        </nz-select>
      </div>
      } @if (shwRdCks==true) {
      <div class="flex flex-col h-full">
        <label
          class="block text-sm font-semibold text-gray-700 mb-2 opacity-0 pointer-events-none"
          >Checkbox</label
        >
        <div class="flex items-center filter-input-height">
          <label
            nz-checkbox
            [(ngModel)]="rdchked"
            (ngModelChange)="rdChkd($event)"
            class="text-sm font-medium text-gray-700"
          >
            Show Deviation Reported
          </label>
        </div>
      </div>
      } @if (shwChckbox==true) {
      <div class="flex flex-col h-full">
        <label
          class="block text-sm font-semibold text-gray-700 mb-2 opacity-0 pointer-events-none"
          >Checkbox</label
        >
        <div
          class="flex items-center justify-between gap-4 filter-input-height"
        >
          <label
            nz-checkbox
            [(ngModel)]="checked"
            (ngModelChange)="deSelectChk($event)"
            class="text-sm font-medium text-gray-700 flex-1"
          >
            Plot all Routes by selecting each route
          </label>
          <button
            nz-button
            nzType="primary"
            (click)="clearRouteMapLayers()"
            class="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium text-sm whitespace-nowrap cursor-pointer"
          >
            Clear Map
          </button>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Map and Vehicle List Section - Side by Side Layout -->
  <div
    class="flex flex-col md:flex-row gap-4 w-full"
    style="
      min-height: 600px;
      align-items: stretch;
      display: flex !important;
      width: 100%;
      position: relative;
    "
  >
    <!-- Left Section: Vehicle Trip List - Fixed Width -->
    @if (!shwNodata) {
    <div
      class="w-full md:w-96 lg:w-[400px] flex-shrink-0 bg-gradient-to-b from-blue-50 to-cyan-50 leftsctn rounded-xl shadow-md overflow-hidden"
      style="min-height: 600px; max-width: 400px"
    >
      <!-- Search Vehicle Section in Left Panel -->
      <div class="p-3 bg-white border-b border-gray-200">
        <label class="block text-sm font-semibold text-gray-700 mb-2"
          >Search Vehicle</label
        >
        <div class="flex items-center gap-2">
          <nz-input-wrapper class="flex-1">
            <input
              type="text"
              nz-input
              [(ngModel)]="searchText"
              placeholder="Search here"
              (ngModelChange)="onInput($event)"
              [ngModelOptions]="{ standalone: true }"
              class="w-full filter-input-height px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            />
          </nz-input-wrapper>
          <button
            (click)="toggleSearchFilters()"
            [class]="
              showSearchFilters
                ? 'flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 border-0 cursor-pointer'
                : 'flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 border-0 cursor-pointer'
            "
          >
            <span
              nz-icon
              nzType="filter"
              nzTheme="outline"
              class="text-base"
            ></span>
          </button>
        </div>
      </div>
      <div
        class="h-full overflow-y-auto custom-scrollbar p-1.5"
        style="height: calc(600px - 125px)"
      >
        @for (c of vehTrpLst; track c; let i = $index) {
        <div
          [ngClass]="c.rn_sts == 1 ? 'border-2 border-red-300' : ''"
          class="mb-2"
        >
          <div
            class="trpdtlsstyles rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 border-l-4 overflow-hidden relative"
            [ngClass]="
              c.isSelected == true
                ? 'bg-gradient-to-br from-red-50 via-red-100/50 to-pink-50/30 border-l-red-600 border-4 border-red-400 shadow-xl ring-4 ring-red-200/50'
                : 'bg-white border-l-blue-500'
            "
          >
            <!-- Main Content - Always Visible -->
            <div class="p-3 cursor-pointer" (click)="getTripMap(c, slctdDt)">
              <!-- Header Section -->
              <div class="flex items-start justify-between mb-3">
                <div class="flex-1 min-w-0">
                  <!-- Vehicle Name Row -->
                  <div class="flex items-center justify-between gap-2 mb-2">
                    <div class="flex items-center gap-3 flex-wrap flex-1">
                      <div class="flex items-center gap-1.5">
                        <span class="text-xs text-gray-500 font-medium"
                          >Vehicle:</span
                        >
                        <h3
                          class="text-sm font-bold text-gray-900 truncate mb-0"
                        >
                          {{ c.asrt_nm }}
                        </h3>
                      </div>
                      @if (c.actl_asrt) {
                      <div class="flex items-center gap-1.5">
                        <span class="text-xs text-gray-500 font-medium"
                          >Actual:</span
                        >
                        <h3
                          class="text-sm font-bold text-gray-900 truncate mb-0"
                        >
                          {{ c.actl_asrt }}
                        </h3>
                      </div>
                      }
                      <div class="flex items-center gap-1.5">
                        <span class="text-xs text-gray-500 font-medium"
                          >Category:</span
                        >
                        <span
                          class="inline-flex items-center px-2 py-0.5 text-gray-700 font-medium text-xs"
                        >
                          {{ c.asrt_ctgry_nm }}
                        </span>
                      </div>
                    </div>
                    <!-- Settings & Parking Icons — edit-only actions, hidden when
                        the user's role has no updt_in on the Dashboard object. -->
                    @if (USER_PERMISSIONS.updt_in == 1) {
                    <div class="flex items-center gap-1.5 flex-shrink-0">
                      <i
                        nz-icon
                        nzType="setting"
                        nzTheme="outline"
                        (click)="openOprtsSldr(c); $event.stopPropagation()"
                        class="text-gray-500 hover:text-blue-600 cursor-pointer transition-colors text-base p-1 hover:bg-blue-50 rounded"
                      ></i>
                      @if (c.trp_sqnc_nu == 1) {
                      <img
                        src="../../../../../assets/images/prkng.png"
                        (click)="dnldPrkngDta(c); $event.stopPropagation()"
                        class="w-5 h-5 cursor-pointer hover:scale-110 transition-transform"
                      />
                      }
                    </div>
                    }
                  </div>
                  <!-- Trip Info Row - Beautifully Aligned -->
                  <div class="flex items-center gap-2 flex-wrap mb-2">
                    <span
                      class="inline-flex items-center px-2 py-1 rounded-lg bg-indigo-50 text-indigo-700 font-semibold text-xs border border-indigo-200 shadow-sm"
                    >
                      Trip #{{ c.trp_sqnc_nu }}
                    </span>
                    @if (c.rd_in) {
                    <span
                      class="inline-flex items-center px-2 py-1 rounded-lg text-xs font-bold text-red-700 bg-red-100 border border-red-300 shadow-sm"
                    >
                      Route Deviated
                    </span>
                    }
                    <span
                      class="inline-flex items-center px-2 py-1 rounded-lg bg-blue-50 text-blue-700 font-semibold text-xs border border-blue-200 shadow-sm"
                    >
                      {{ c.trip_sts }}
                    </span>
                    @if (c.trp_stats_in==1) {
                    <span
                      class="inline-flex items-center px-2 py-1 rounded-lg bg-green-50 text-green-700 font-semibold text-xs border border-green-200 shadow-sm"
                    >
                      {{ c.cvrg_prcntg_ct }}% Covered
                    </span>
                    }
                  </div>
                  <div class="flex flex-wrap items-center gap-1.5 text-xs">
                    @if (ShowClap) {
                    <span
                      class="inline-flex items-center px-2 py-0.5 rounded-md bg-gray-50 text-gray-700 font-medium border border-gray-200"
                    >
                      <span class="text-gray-500 mr-1">Vendor:</span
                      >{{ c.vndr_nm }}
                    </span>
                    } @if (c.wrd_nm) {
                    <span
                      class="inline-flex items-center px-2 py-0.5 text-gray-700 font-medium"
                    >
                      <span class="text-gray-500 mr-1">Ward:</span
                      >{{ c.wrd_nm }}
                    </span>
                    } @if (svmLst && svmLst.length > 0 && clntDtls[0].clnt_id==7
                    && c.schivalayam != null) {
                    <span
                      class="inline-flex items-center px-2 py-0.5 text-gray-700 font-medium"
                    >
                      <span class="text-gray-500 mr-1">Sachivalayam:</span
                      >{{ c.schivalayam }}
                    </span>
                    } @if (wrds && wrds.length > 0 && clntDtls[0].clnt_id!=7 &&
                    c.wrd_nm) {
                    <span
                      class="inline-flex items-center px-2 py-0.5 text-gray-700 font-medium"
                    >
                      <span class="text-gray-500 mr-1">Ward:</span
                      >{{ c.wrd_nm }}
                    </span>
                    }
                  </div>
                </div>
              </div>
              <!-- From/To Location Section with Expand Button -->
              <div class="mt-2 flex items-center gap-2">
                <!-- From/To Box -->
                <div
                  class="flex-1 rounded-lg p-2.5 border border-gray-200 space-y-1.5"
                >
                  <!-- From Location -->
                  <div class="flex items-center gap-2">
                    <i
                      nz-icon
                      nzType="environment"
                      nzTheme="outline"
                      class="text-green-600 text-sm flex-shrink-0"
                    ></i>
                    <span
                      class="text-[10px] text-green-600 font-semibold uppercase"
                      >From:</span
                    >
                    <p class="text-xs font-semibold text-gray-800 mb-0">
                      {{ c.strt_fnce_nm }}
                    </p>
                  </div>
                  <!-- To Location -->
                  <div class="flex items-center gap-2">
                    <i
                      nz-icon
                      nzType="flag"
                      nzTheme="outline"
                      class="text-red-600 text-sm flex-shrink-0"
                    ></i>
                    <span
                      class="text-[10px] text-red-600 font-semibold uppercase"
                      >To:</span
                    >
                    <p class="text-xs font-semibold text-gray-800 mb-0">
                      {{ c.end_fnce_nm }}
                    </p>
                  </div>
                </div>
                <!-- Expand/Collapse Button (Outside) -->
                <button
                  (click)="toggleCardDetails(i, $event)"
                  class="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-blue-50 hover:bg-blue-100 border border-blue-200 transition-all duration-200 cursor-pointer"
                >
                  <svg
                    class="w-4 h-4 text-blue-600 transition-transform duration-200"
                    [class.rotate-180]="isCardExpanded(i)"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg>
                </button>
              </div>
              <!-- Sachivalayam/Ward Section -->
              <!-- <div class="mb-2" *ngIf="svmLst && svmLst.length > 0 && clntDtls[0].clnt_id==7">
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-semibold text-gray-500">Sachivalayam:</span>
                    <span class="text-xs font-bold text-gray-800" *ngIf="c.schivalayam != null">{{c.schivalayam}}</span>
                    <span class="text-xs text-gray-400" *ngIf="c.schivalayam == null">--</span>
                  </div>
                </div>
                <div class="mb-2" *ngIf="wrds && wrds.length > 0 && clntDtls[0].clnt_id!=7">
                  <div class="flex items-center gap-2">
                    <span class="text-xs font-semibold text-gray-500">Ward:</span>
                    <span class="text-xs font-bold text-gray-800" *ngIf="c.wrd_nm != null">{{c.wrd_nm}}</span>
                    <span class="text-xs text-gray-400" *ngIf="c.wrd_nm == null">--</span>
                  </div>
                </div> -->
            </div>
            <!-- Collapsible Details Section -->
            @if (isCardExpanded(i)) {
            <div
              class="px-3 pb-3 border-t border-gray-200 bg-gray-50/50 transition-all duration-300 ease-in-out"
            >
              <!-- Schedule and Actual Timings Section -->
              <div class="grid grid-cols-2 gap-3 mt-3 mb-3">
                <div
                  class="bg-gradient-to-br from-red-50 to-pink-50 rounded-lg p-2.5 border border-red-200 shadow-sm"
                >
                  <div class="flex items-center gap-1.5 mb-2">
                    <span
                      nz-icon
                      nzType="environment"
                      nzTheme="filled"
                      class="text-red-500 text-sm"
                    ></span>
                    <span
                      class="text-xs font-bold text-gray-700 uppercase tracking-wide"
                      >From Location</span
                    >
                  </div>
                  <div class="space-y-1">
                    <div class="flex items-center justify-between">
                      <span class="text-xs text-gray-500">Schedule:</span>
                      <span class="text-xs font-semibold text-gray-800">{{
                        c.sch_strt_tm
                      }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                      <span class="text-xs text-gray-500">Actual:</span>
                      <span class="text-xs font-semibold text-gray-800">{{
                        c.actl_strt_ts
                      }}</span>
                    </div>
                  </div>
                </div>
                <div
                  class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-2.5 border border-green-200 shadow-sm"
                >
                  <div class="flex items-center gap-1.5 mb-2">
                    <span
                      nz-icon
                      nzType="environment"
                      nzTheme="filled"
                      class="text-green-500 text-sm"
                    ></span>
                    <span
                      class="text-xs font-bold text-gray-700 uppercase tracking-wide"
                      >To Location</span
                    >
                  </div>
                  <div class="space-y-1">
                    <div class="flex items-center justify-between">
                      <span class="text-xs text-gray-500">Schedule:</span>
                      <span class="text-xs font-semibold text-gray-800">{{
                        c.sch_end_tm
                      }}</span>
                    </div>
                    <div class="flex items-center justify-between">
                      <span class="text-xs text-gray-500">Actual:</span>
                      <span class="text-xs font-semibold text-gray-800">{{
                        c.actl_end_ts
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Distance and Time Section -->
              <div class="grid grid-cols-2 gap-2">
                <div
                  class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-2 border border-blue-200 shadow-sm"
                >
                  <div class="text-xs text-gray-600 mb-1">
                    Schedule Distance
                  </div>
                  <div class="text-sm font-bold text-blue-700">
                    {{ c.sch_dstnc_ct || "-" }} KM
                  </div>
                </div>
                <div
                  class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-2 border border-purple-200 shadow-sm"
                >
                  <div class="text-xs text-gray-600 mb-1">Schedule Time</div>
                  <div class="text-sm font-bold text-purple-700">
                    {{ c.schl_trvl_tm || "-" }}
                  </div>
                </div>
                <div
                  class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-2 border border-green-200 shadow-sm"
                >
                  <div class="text-xs text-gray-600 mb-1">Actual Distance</div>
                  <div class="text-sm font-bold text-green-700">
                    {{ c.actl_trvl_dstne_ct || "-" }} KM
                  </div>
                </div>
                <div
                  class="bg-gradient-to-br from-orange-50 to-amber-50 rounded-lg p-2 border border-orange-200 shadow-sm"
                >
                  <div class="text-xs text-gray-600 mb-1">Actual Time</div>
                  <div class="text-sm font-bold text-orange-700">
                    {{ c.actl_trvl_tm || "-" }}
                  </div>
                </div>
              </div>
            </div>
            }
            <!-- Action Buttons -->
            <div
              class="flex flex-wrap items-center justify-center gap-2 border-t border-gray-200 bg-gray-50/30"
            >
              @if (c.rd_in==1 && c.drvr_cntctd_in==1) {
              <div>
                <button
                  (click)="deviateSlider(c); $event.stopPropagation()"
                  class="inline-flex items-center mb-2 gap-1.5 px-3 py-1.5 text-xs font-semibold text-blue-600 hover:text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-all duration-200 hover:shadow-sm cursor-pointer"
                >
                  <svg
                    class="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                  Check Deviation Info
                </button>
              </div>
              }
              <!-- Report Deviation — opens the write slider (addDvtnRsn INSERT).
                Gated on updt_in per the RBAC spec so read-only users on the
                Dashboard object don't see the button at all. The Submit action
                inside the slider is separately gated by perms.canWrite() so
                there's a defence-in-depth check even if this button ever leaks. -->
              @if (c.rd_in==1 && c.drvr_cntctd_in!=1 && USER_PERMISSIONS.updt_in
              == 1) {
              <button
                (click)="deviateSlider(c); $event.stopPropagation()"
                class="inline-flex items-center gap-2 px-4 py-2 mb-2 bg-gradient-to-r from-red-500 via-red-600 to-pink-600 hover:from-red-600 hover:via-red-700 hover:to-pink-700 text-white text-xs font-bold rounded-md shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 relative overflow-hidden group cursor-pointer"
              >
                <span
                  class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                ></span>
                <svg
                  class="w-4 h-4 relative z-10"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  ></path>
                </svg>
                <span class="relative z-10">Report Deviation</span>
              </button>
              }
              <!-- Route-action buttons — gated by BOTH the legacy role/tenant
                check AND the fresh role→object permission flags. Add and
                Set-as-master require insrt_in (creating a master route);
                Edit requires updt_in (mutating an existing polyline). Users
                without either write flag see none of these buttons. -->
              @if (userDtls.rle_id!=37 && clntDtls[0].clnt_id!=3000001 &&
              (USER_PERMISSIONS.insrt_in == 1 || USER_PERMISSIONS.updt_in == 1))
              {
              <div class="flex gap-1.5 flex-wrap justify-center">
                @if (c.shwEdtBtn && c.has_rte_plyln==0 &&
                USER_PERMISSIONS.insrt_in == 1) {
                <button
                  (click)="editRoute(c, 'nw'); $event.stopPropagation()"
                  class="inline-flex items-center gap-1.5 px-4 py-2 mb-2 bg-gradient-to-r from-green-500 via-emerald-500 to-green-600 hover:from-green-600 hover:via-emerald-600 hover:to-green-700 text-white text-xs font-bold rounded-md shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 relative overflow-hidden group cursor-pointer"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                  ></span>
                  <svg
                    class="w-3.5 h-3.5 relative z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                      d="M12 4v16m8-8H4"
                    ></path>
                  </svg>
                  <span class="relative z-10">Add</span>
                </button>
                } @if (c.shwEdtBtn && c.has_rte_plyln==1 &&
                USER_PERMISSIONS.updt_in == 1) {
                <button
                  (click)="editRoute(c, 'edt'); $event.stopPropagation()"
                  class="inline-flex items-center gap-1.5 px-4 py-2 mb-2 bg-gradient-to-r from-yellow-500 via-amber-500 to-yellow-600 hover:from-yellow-600 hover:via-amber-600 hover:to-yellow-700 text-white text-xs font-bold rounded-md shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 relative overflow-hidden group cursor-pointer"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                  ></span>
                  <svg
                    class="w-3.5 h-3.5 relative z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    ></path>
                  </svg>
                  <span class="relative z-10">Edit</span>
                </button>
                } @if (c.shwAddBtn && USER_PERMISSIONS.insrt_in == 1) {
                <button
                  (click)="setMasterRoute(); $event.stopPropagation()"
                  class="inline-flex items-center gap-1.5 px-4 py-2 mb-2 bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-600 hover:from-teal-600 hover:via-cyan-600 hover:to-teal-700 text-white text-xs font-bold rounded-md shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 relative overflow-hidden group cursor-pointer"
                >
                  <span
                    class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                  ></span>
                  <svg
                    class="w-3.5 h-3.5 relative z-10"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                      d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                    ></path>
                  </svg>
                  <span class="relative z-10">Set as master Route</span>
                </button>
                }
              </div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      <!-- Pagination Controls -->
      @if (totalTrips > 0) {
      <div
        class="flex items-center justify-between px-3 py-2 bg-white border-t border-gray-200"
      >
        <span class="text-xs text-gray-500">{{ totalTrips }} trips</span>
        <div class="flex items-center gap-1">
          <button
            (click)="onPageChange(currentPage - 1)"
            [disabled]="currentPage <= 1"
            class="w-7 h-7 flex items-center justify-center rounded text-xs border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            <span nz-icon nzType="left" nzTheme="outline"></span>
          </button>
          <span class="text-xs text-gray-700 px-2"
            >{{ currentPage }} / {{ getTotalPages() }}</span
          >
          <button
            (click)="onPageChange(currentPage + 1)"
            [disabled]="currentPage >= getTotalPages()"
            class="w-7 h-7 flex items-center justify-center rounded text-xs border border-gray-300 bg-white hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            <span nz-icon nzType="right" nzTheme="outline"></span>
          </button>
        </div>
      </div>
      }
    </div>
    }

    <!-- No Data Message -->
    @if (shwNodata) {
    <div
      class="w-full md:w-96 lg:w-[400px] flex-shrink-0 bg-gradient-to-b from-blue-50 to-cyan-50 rounded-xl shadow-md flex items-center justify-center"
      style="min-height: 600px; max-width: 400px; flex-grow: 0; flex-shrink: 0"
    >
      <p class="text-lg font-semibold text-gray-600 px-4 text-center">
        No Trips Found for Selected Option(s)
      </p>
    </div>
    }

    <!-- Map Section - Right Side, Always Visible, Takes Remaining Space -->
    <div
      class="map-section-wrapper flex-1 min-w-0 bg-white rounded-xl shadow-md overflow-hidden"
      style="
        height: 600px;
        position: relative;
        min-height: 600px;
        flex: 1 1 0% !important;
        border: 1px solid #e5e7eb;
      "
    >
      <div
        id="routeDevtmap"
        style="
          height: 600px !important;
          min-height: 600px !important;
          width: 100% !important;
          display: block !important;
          position: relative !important;
          visibility: visible !important;
          z-index: 1;
          background-color: #e8f4f8;
        "
      ></div>

      <!-- Route Legend Overlay on Map -->
      <div
        class="absolute top-4 left-4rem z-10 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg border border-gray-200 p-3"
      >
        <div class="flex flex-col gap-2">
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 bg-green-600 rounded"></div>
            <span class="text-xs font-semibold text-gray-700"
              >Scheduled Route</span
            >
          </div>
          <div class="flex items-center gap-2">
            <div class="w-4 h-4 bg-red-500 rounded"></div>
            <span class="text-xs font-semibold text-gray-700"
              >Travelled Route</span
            >
          </div>
          @for (v of SlctdWrdPolyData; track v) {
          <div class="flex items-center gap-2">
            <div
              class="w-4 h-4 rounded"
              [ngStyle]="{ 'background-color': v.clr_obj }"
            ></div>
            <span class="text-xs font-semibold text-gray-700"
              >{{ v.asrt_nm }} Trip:{{ v.trp_sqnc_nu }}</span
            >
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Modern Modal -->
  <nz-modal
    [(nzVisible)]="isVisible"
    (nzOnCancel)="handleCancel()"
    nzWidth="1000"
    [nzTitle]=""
  >
    <ng-container *nzModalContent>
      <div class="mb-4 pb-4 border-b border-gray-200">
        <div class="flex flex-wrap items-center gap-4 mb-4">
          <div class="flex-1 flex gap-3">
            <nz-date-picker
              nzShowTime
              (ngModelChange)="onselectPbStrtTime($event)"
              [(ngModel)]="Pbstrt_tm"
              class="flex-1"
            >
            </nz-date-picker>
            <nz-date-picker
              nzShowTime
              (ngModelChange)="onselectPbEndTime($event)"
              [(ngModel)]="Pbend_tm"
              class="flex-1"
            >
            </nz-date-picker>
            <button
              nz-button
              nzType="primary"
              (click)="getPlayBack()"
              class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all"
            >
              Get Playback
            </button>
          </div>
          <div class="flex gap-2">
            @for (l of tileLayers; track l) {
            <div
              (click)="chklyrSlct(l)"
              [ngClass]="
                l.lyrSlct == true
                  ? 'bg-blue-100 border-blue-500 text-blue-700'
                  : 'bg-gray-50 border-gray-300 text-gray-600'
              "
              class="px-3 py-2 border-2 rounded-lg cursor-pointer transition-all hover:shadow-md"
            >
              {{ l.lyr_nm }} View
            </div>
            }
          </div>
          <button
            nz-button
            nzType="primary"
            (click)="clearEditablePolyline()"
            class="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all"
          >
            Clear
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="downloadPdf()"
            class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all"
          >
            <span nz-icon nzType="download" nzTheme="outline"></span>
          </button>
        </div>
        @if (selectedtenant==1000033) {
        <div class="mt-2">
          <label
            nz-checkbox
            [(ngModel)]="svmChkd"
            (ngModelChange)="onSvmChk($event)"
            class="text-sm font-medium text-gray-700"
          >
            Show Sachivalayam
          </label>
        </div>
        }
      </div>

      <div class="mb-4 pb-2">
        <h3 class="text-lg font-bold text-gray-800">
          {{ rteSaveData.asrt_nm }} - Trip:{{ rteSaveData.trp_sqnc_nu }}
        </h3>
      </div>
      <div
        [ngClass]="{
          'map-no-sidebar col-md-8': map_stng.show_build_sidebar == true,
          'map-with-sidebar col-md-12': map_stng.show_build_sidebar != true
        }"
      >
        <div
          leaflet
          style="height: 1200px; width: 140%; margin: 0; padding: 0"
          leafletDraw
          (leafletMapReady)="onMapReady($event)"
          [leafletOptions]="leafletOptions"
          [leafletLayers]="layers"
          [leafletDrawOptions]="drawOptions"
          [leafletDrawLocal]="drawLocal"
          (leafletDrawCreated)="onDrawCreated($event)"
          (leafletDrawStart)="onDrawStart($event)"
          (leafletDrawEditStart)="onDrawStart($event)"
          (leafletDrawEditStop)="onDrawEditStop($event)"
          (leafletDrawDeleteStart)="onDrawStart($event)"
          (leafletDrawDeleteStop)="onDrawStart($event)"
        ></div>
      </div>
    </ng-container>
  </nz-modal>
</div>
<!-- </div>
</div> -->
<!-- Modern Drawer - Route Deviation Feedback -->
<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="drawerWidth"
  [nzVisible]="openSlider"
  class="sldrCls"
  nzTitle="Route Deviation Feedback"
  (nzOnClose)="closeSideBar()"
>
  <ng-container *nzDrawerContent>
    <div class="bg-white rounded-lg shadow-sm p-4 mb-4">
      <div class="space-y-3">
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600"
            >Vehicle Number</span
          >
          <span class="text-sm font-bold text-gray-800">{{
            slctdDtls.asrt_nm
          }}</span>
        </div>
        @if (slctdDtls.svm_nm) {
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600">Sachivalayam</span>
          <span class="text-sm font-bold text-gray-800">{{
            slctdDtls.svm_nm
          }}</span>
        </div>
        } @if (slctdDtls.crw_nm) {
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600">Driver Name</span>
          <span class="text-sm font-bold text-gray-800">{{
            slctdDtls.crw_nm
          }}</span>
        </div>
        } @if (slctdDtls.crw_ph) {
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600"
            >Driver Contact</span
          >
          <span class="text-sm font-bold text-gray-800">{{
            slctdDtls.crw_ph
          }}</span>
        </div>
        }
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600"
            >Driver Contacted</span
          >
          <span
            class="text-sm font-bold"
            [ngClass]="{
              'text-gray-500': slctdDtls.drvr_cntctd_in == undefined,
              'text-green-600': slctdDtls.drvr_cntctd_in == 1,
              'text-red-600': slctdDtls.drvr_cntctd_in == 0
            }"
          >
            @if (slctdDtls.drvr_cntctd_in==undefined) {
            <span>Yet To Be Contacted</span>
            } @if (slctdDtls.drvr_cntctd_in==1) {
            <span>Yes</span>
            } @if (slctdDtls.drvr_cntctd_in==0) {
            <span>No</span>
            }
          </span>
        </div>
        @if (slctdDtls.drvr_cntctd_in) {
        <div
          class="flex justify-between items-center py-2 border-b border-gray-100"
        >
          <span class="text-sm font-semibold text-gray-600"
            >Deviation Accepted</span
          >
          <span
            class="text-sm font-bold"
            [ngClass]="{
              'text-gray-500': slctdDtls.rte_dvtn_acpt_in == undefined,
              'text-green-600': slctdDtls.rte_dvtn_acpt_in == 1,
              'text-red-600': slctdDtls.rte_dvtn_acpt_in == 0
            }"
          >
            @if (slctdDtls.rte_dvtn_acpt_in==undefined) {
            <span>Not Known</span>
            } @if (slctdDtls.rte_dvtn_acpt_in==1) {
            <span>Yes</span>
            } @if (slctdDtls.rte_dvtn_acpt_in==0) {
            <span>No</span>
            }
          </span>
        </div>
        } @if (slctdDtls.dvtn_rsn_tx) {
        <div class="flex justify-between items-start py-2">
          <span class="text-sm font-semibold text-gray-600"
            >Reason For Deviation</span
          >
          <span
            class="text-sm font-medium text-gray-800 text-right flex-1 ml-4"
            >{{ slctdDtls.dvtn_rsn_tx }}</span
          >
        </div>
        }
      </div>
    </div>
    @if (slctdDtls.drvr_cntctd_in!=1) {
    <div class="bg-gray-50 rounded-lg p-4">
      <h3
        class="text-lg font-bold text-gray-800 mb-4 text-center bg-blue-100 py-2 rounded-lg"
      >
        Feedback on Route Deviation
      </h3>
      <form nz-form [formGroup]="dvtnForm" class="space-y-4">
        <div>
          <nz-form-label class="block text-sm font-semibold text-gray-700 mb-2"
            >Driver Contacted</nz-form-label
          >
          <nz-form-item>
            <nz-form-control>
              <nz-radio-group
                formControlName="drvr_cntctd_in"
                class="flex gap-4"
              >
                <label nz-radio nzValue="1" class="text-sm">Yes</label>
                <label nz-radio nzValue="0" class="text-sm">No</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-label class="block text-sm font-semibold text-gray-700 mb-2"
            >Route Deviation Accepted</nz-form-label
          >
          <nz-form-item>
            <nz-form-control>
              <nz-radio-group
                formControlName="rte_dvtn_acpt_in"
                class="flex gap-4"
              >
                <label nz-radio nzValue="1" class="text-sm">Yes</label>
                <label nz-radio nzValue="0" class="text-sm">No</label>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div>
          <nz-form-label class="block text-sm font-semibold text-gray-700 mb-2"
            >Reason</nz-form-label
          >
          <nz-form-item>
            <nz-form-control>
              <input
                nz-input
                formControlName="dvtn_rsn_tx"
                placeholder="Enter reason for deviation"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
      <div class="flex justify-center gap-3 mt-6">
        <button
          nz-button
          (click)="closeSideBar()"
          nzType="primary"
          nzDanger
          class="px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all cursor-pointer"
        >
          Cancel
        </button>
        @if (dvtnForm.status == 'VALID') {
        <button
          nz-button
          (click)="addDvtnRsn()"
          [nzLoading]="isSavingRsn"
          [disabled]="isSavingRsn || !perms.canWrite()"
          [title]="
            !perms.canWrite() ? 'You do not have permission to submit' : ''
          "
          class="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md hover:shadow-lg transition-all cursor-pointer"
        >
          {{ isSavingRsn ? "Saving..." : "Submit" }}
        </button>
        }
      </div>
    </div>
    } @if (slctdDtls.drvr_cntctd_in==1) {
    <div class="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
      <p class="text-green-700 font-semibold">Details Already Updated</p>
    </div>
    }
  </ng-container>
</nz-drawer>
<!-- Modern Drawer - Trip Details -->
<nz-drawer
  [nzBodyStyle]="{
    overflow: 'auto',
    background: 'linear-gradient(to bottom, #f8fafc, #f1f5f9)'
  }"
  [nzMaskClosable]="false"
  [nzWidth]="drawerWidthLg"
  [nzVisible]="openOprtnSlider"
  class="sldrCls"
  nzTitle="Trip Details"
  (nzOnClose)="closeOprtnSideBar()"
>
  <ng-container *nzDrawerContent>
    <!-- Trip Information Card -->
    @if (oprtnsData) {
    <div
      class="bg-gradient-to-br from-white via-blue-50/30 to-indigo-50/20 rounded-xl shadow-lg border border-gray-200 p-3 mb-3"
    >
      <div class="flex items-center gap-2 mb-1 pb-2 border-b-2 border-blue-200">
        <div
          class="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-md"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            ></path>
          </svg>
        </div>
        <div>
          <h2 class="text-base font-bold text-gray-900 mb-0">
            Trip Information
          </h2>
          <p class="text-xs text-gray-500">Complete trip details</p>
        </div>
      </div>
      <div class="space-y-1">
        <div
          class="flex justify-between items-center p-2 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="car"
              nzTheme="outline"
              class="text-blue-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600"
              >Vehicle Number</span
            >
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-blue-50 px-3 py-1 rounded-md border border-blue-200"
            >{{ oprtnsData.asrt_nm }}</span
          >
        </div>
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="tags"
              nzTheme="outline"
              class="text-indigo-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600"
              >Vehicle Category</span
            >
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-indigo-50 px-3 py-1 rounded-md border border-indigo-200"
            >{{ oprtnsData.asrt_ctgry_nm }}</span
          >
        </div>
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="number"
              nzTheme="outline"
              class="text-purple-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600">Trip No</span>
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-purple-50 px-3 py-1 rounded-md border border-purple-200"
            >#{{ oprtnsData.trp_sqnc_nu }}</span
          >
        </div>
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="check-circle"
              nzTheme="outline"
              class="text-green-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600">Trip Status</span>
          </div>
          <span
            class="text-sm font-bold px-3 py-1 rounded-md border"
            [ngClass]="
              oprtnsData.rd_in == 1
                ? 'text-red-700 bg-red-50 border-red-200'
                : 'text-green-700 bg-green-50 border-green-200'
            "
          >
            {{ oprtnsData.trip_sts }}
          </span>
        </div>
        @if (oprtnsData.svm_nm) {
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="home"
              nzTheme="outline"
              class="text-teal-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600"
              >Sachivalayam</span
            >
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-teal-50 px-3 py-1 rounded-md border border-teal-200"
            >{{ oprtnsData.svm_nm }}</span
          >
        </div>
        } @if (oprtnsData.crw_nm) {
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="user"
              nzTheme="outline"
              class="text-cyan-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600">Driver Name</span>
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-cyan-50 px-3 py-1 rounded-md border border-cyan-200"
            >{{ oprtnsData.crw_nm }}</span
          >
        </div>
        } @if (oprtnsData.crw_ph) {
        <div
          class="flex justify-between items-center p-3 bg-white/60 rounded-lg border border-gray-200/50 hover:bg-white/80 transition-colors"
        >
          <div class="flex items-center gap-2">
            <span
              nz-icon
              nzType="phone"
              nzTheme="outline"
              class="text-pink-600"
            ></span>
            <span class="text-sm font-semibold text-gray-600"
              >Driver Contact</span
            >
          </div>
          <span
            class="text-sm font-bold text-gray-900 bg-pink-50 px-3 py-1 rounded-md border border-pink-200"
            >{{ oprtnsData.crw_ph }}</span
          >
        </div>
        }
      </div>
      <!-- Location Details -->
      <div class="pt-3 border-t-2 border-gray-200">
        <div class="grid grid-cols-2 gap-2">
          <div
            class="bg-gradient-to-br from-red-50 to-pink-50 rounded-lg p-2 border border-red-200"
          >
            <div class="flex items-center gap-2 mb-2">
              <span
                nz-icon
                nzType="environment"
                nzTheme="filled"
                class="text-red-500"
              ></span>
              <span
                class="text-xs font-bold text-gray-700 uppercase tracking-wide"
                >From</span
              >
            </div>
            <div class="text-sm font-bold text-gray-900 mb-1">
              {{ oprtnsData.strt_fnce_nm }}
            </div>
            <div class="space-y-1">
              <div class="text-xs text-gray-600">
                <span class="font-semibold">Schedule:</span>
                {{ oprtnsData.sch_strt_tm }}
              </div>
              <div class="text-xs text-gray-600">
                <span class="font-semibold">Actual:</span>
                {{ oprtnsData.actl_strt_ts }}
              </div>
            </div>
          </div>
          <div
            class="bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg p-2 border border-green-200"
          >
            <div class="flex items-center gap-2 mb-2">
              <span
                nz-icon
                nzType="environment"
                nzTheme="filled"
                class="text-green-500"
              ></span>
              <span
                class="text-xs font-bold text-gray-700 uppercase tracking-wide"
                >To</span
              >
            </div>
            <div class="text-sm font-bold text-gray-900 mb-1">
              {{ oprtnsData.end_fnce_nm }}
            </div>
            <div class="space-y-1">
              <div class="text-xs text-gray-600">
                <span class="font-semibold">Schedule:</span>
                {{ oprtnsData.sch_end_tm }}
              </div>
              <div class="text-xs text-gray-600">
                <span class="font-semibold">Actual:</span>
                {{ oprtnsData.actl_end_ts }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }

    <!-- Trip Operations -->
    <div
      class="bg-gradient-to-br from-white via-orange-50/30 to-amber-50/20 rounded-xl shadow-lg border border-orange-200 p-3 mb-3"
    >
      <div
        class="flex items-center gap-2 mb-3 pb-2 border-b-2 border-orange-200"
      >
        <div
          class="w-10 h-10 bg-gradient-to-br from-orange-500 to-amber-600 rounded-xl flex items-center justify-center shadow-md"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            ></path>
          </svg>
        </div>
        <div>
          <h3 class="text-base font-bold text-gray-900 mb-0">
            Trip Operations
          </h3>
          <p class="text-xs text-gray-500">Manage trip actions</p>
        </div>
      </div>
      <div class="grid grid-cols-3 gap-2">
        <button
          (click)="clearTrip()"
          class="flex flex-row items-center justify-center gap-1.5 px-2 py-2 bg-gradient-to-br from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 group cursor-pointer"
        >
          <svg
            class="w-4 h-4 group-hover:rotate-90 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            ></path>
          </svg>
          <span class="text-xs font-bold whitespace-nowrap">Clear Trip</span>
        </button>
        <button
          (click)="StartTrip()"
          class="flex flex-row items-center justify-center gap-1.5 px-2 py-2 bg-gradient-to-br from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 group cursor-pointer"
        >
          <svg
            class="w-4 h-4 group-hover:scale-110 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
          <span class="text-xs font-bold whitespace-nowrap">Start Trip</span>
        </button>
        <button
          (click)="cancelTrip()"
          class="flex flex-row items-center justify-center gap-1.5 px-2 py-2 bg-gradient-to-br from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 group cursor-pointer"
        >
          <svg
            class="w-4 h-4 group-hover:rotate-90 transition-transform duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
          <span class="text-xs font-bold whitespace-nowrap">Cancel</span>
        </button>
      </div>
    </div>

    <!-- Change Vehicle -->
    <div
      class="bg-gradient-to-br from-white via-purple-50/30 to-pink-50/20 rounded-xl shadow-lg border border-purple-200 p-3 mb-3"
    >
      <div
        class="flex items-center gap-2 mb-3 pb-2 border-b-2 border-purple-200"
      >
        <div
          class="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-600 rounded-xl flex items-center justify-center shadow-md"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
            ></path>
          </svg>
        </div>
        <div>
          <h3 class="text-base font-bold text-gray-900 mb-0">Change Vehicle</h3>
          <p class="text-xs text-gray-500">Switch to different vehicle</p>
        </div>
      </div>
      <div class="space-y-3">
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2"
            >Select Vehicle</label
          >
          <nz-select
            class="w-full filter-input-height"
            nzShowSearch
            [(ngModel)]="selectedVehicle"
            (ngModelChange)="onvehcleSelect($event)"
            nzPlaceHolder="Select Vehicle to change Trip"
            [ngModelOptions]="{ standalone: true }"
          >
            @for (v of vhcleslst; track v) {
            <nz-option [nzLabel]="v.asrt_nm" [nzValue]="v.asrt_id"></nz-option>
            }
          </nz-select>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2"
            >Reason for Change</label
          >
          <textarea
            class="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 resize-none"
            rows="2"
            [(ngModel)]="vhclChngeRsn"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Enter reason for vehicle change"
          ></textarea>
        </div>
        <button
          (click)="submitVehicle()"
          class="w-full inline-flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-green-500 via-emerald-500 to-green-600 hover:from-green-600 hover:via-emerald-600 hover:to-green-700 text-white text-sm font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 hover:scale-105 border-0 relative overflow-hidden group cursor-pointer"
        >
          <span
            class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
          ></span>
          <svg
            class="w-4 h-4 relative z-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            ></path>
          </svg>
          <span class="relative z-10">Submit</span>
        </button>
      </div>
    </div>

    <!-- Change Timings -->
    <div
      class="bg-gradient-to-br from-white via-teal-50/30 to-cyan-50/20 rounded-xl shadow-lg border border-teal-200 p-3"
    >
      <div class="flex items-center gap-2 mb-3 pb-2 border-b-2 border-teal-200">
        <div
          class="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center shadow-md"
        >
          <svg
            class="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        <div>
          <h3 class="text-base font-bold text-gray-900 mb-0">Change Timings</h3>
          <p class="text-xs text-gray-500">Update schedule times</p>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2"
            >Schedule Start time</label
          >
          <nz-time-picker
            nzShowTime
            (ngModelChange)="onselectStrtTime($event, oprtnsData)"
            [(ngModel)]="slctdstrt_tm"
            [nzUse12Hours]="true"
            [nzFormat]="timeFormat"
            class="w-full filter-input-height"
          >
          </nz-time-picker>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2"
            >Schedule End time</label
          >
          <nz-time-picker
            nzShowTime
            (ngModelChange)="onselectEndTime($event, oprtnsData)"
            [(ngModel)]="slctdend_tm"
            [nzUse12Hours]="true"
            [nzFormat]="timeFormat"
            class="w-full filter-input-height"
          >
          </nz-time-picker>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>
<nz-modal
  [(nzVisible)]="stpgDtls"
  nzTitle="Trip Stoppage Details"
  (nzOnCancel)="handlestoppage()"
  (nzOnOk)="handleOk()"
  nzWidth="800px"
  nzClassName="prkngdtls"
>
  <ng-container *nzModalContent>
    <app-data-grid
      id="grid"
      class="gridHeight"
      style="width: 100%; max-width: 100% !important"
      [dataSource]="stpgPnts"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="false"
      [filterPanel]="false"
      [groupPanel]="true"
      [columnChooser]="false"
      [allowExport]="true"
      exportFileName="Parking points List"
      [pageSize]="10"
      [allowedPageSizes]="[10, 30, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="false"
      [showBorders]="true"
      [wordWrapEnabled]="true"
    >
      <!-- [width]="f.field == 'sno' ?80:200" -->

      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons_edit"
        [width]="100"
        caption="Location"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="cursor-pointer tblEdtBtn" (click)="vewonMap(data.data)">
            Map View
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </ng-container>
</nz-modal>
